import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ParkingDeck} from '../services/data.service';

@Component({
  selector: 'app-list-item',
  templateUrl: './list-item.component.html',
  styleUrls: ['./list-item.component.scss']
})
export class ListItemComponent implements OnInit {

  constructor() { }

  @Input() deck: ParkingDeck;
  @Output() toggled = new EventEmitter<ParkingDeck>();

  private disabledLink = false;

  ngOnInit() {
  }

  toggleFavorite(deck: ParkingDeck) {
    this.toggled.emit(deck);
  }

  navigate(link: string, event) {
    if (! this.disabledLink) {
      event.stopPropagation();
      window.open(link, '_blank');
      this.disabledLink = true;

      setTimeout(() => this.disabledLink = false, 800);
    }
  }
}
